import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"flat":"","loading":_vm.loading}},[_c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{staticClass:"mt-4"},[_vm._t("content")],2)],1),_c(VDivider),_c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"xl":"12","lg":"12","md":"12","sm":"12","xs":"12"}},[_vm._t("actions")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }